@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@uom-row-height: 32px;
@uom-grid-template: 60px 80px 1fr 1fr 120px 60px 60px 30px;

.uom-tab {
  padding: @space-0 @space-16 @space-16;
}

.content-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
  padding: @space-16;
}

.card-header {
  justify-content: space-between;
  align-items: flex-start;
  gap: @space-16;
  margin-bottom: @space-16;
}

.card-subtitle {
  padding: @space-4 @space-0 @space-12;
}

.print-barcodes-btn {
  white-space: nowrap;
  display: inline-flex;
  gap: @space-8;
  align-items: center;
  flex-shrink: 0;
}

.uom-grid {
  margin-top: @space-8;
  border: 1px solid var(--gray-DFE4E8);
  border-radius: @space-4;
  overflow-x: auto;
}

.uom-grid-header,
.uom-row {
  display: grid;
  grid-template-columns: @uom-grid-template;
  column-gap: @space-8;
  padding: @space-8 @space-12;
  align-items: flex-start;
}

.uom-grid-header {
  background-color: @table--header--background-color;
  border-bottom: 1px solid var(--gray-DFE4E8);
  font-weight: 500;
  line-height: @uom-row-height;
}

.uom-row {
  border-top: 1px solid var(--gray-DFE4E8);
}

.uom-row:first-of-type {
  border-top: none;
}

.uom-loading {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  padding: @space-16 @space-0;
  height: 100px;
}

.cell-readonly {
  height: @uom-row-height;
  line-height: @uom-row-height;
  padding: 0;
  color: var(--gray-45505B);
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-actions {
  position: relative;
  display: flex;
  gap: @space-4;
  justify-content: flex-end;
  height: @uom-row-height;
  align-items: center;
}

.menu-toggle {
  width: 32px;
  border-radius: 6px;
  color: var(--grey-800);
}

.menu-toggle:hover,
.menu-toggle:focus {
  background-color: var(--blue-200);
  color: var(--blue-900);
}

.menu-toggle:active {
  background-color: var(--grey-100);
  color: var(--grey-850);
}

.menu-toggle-open {
  background-color: var(--grey-100);
  color: var(--grey-850);
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;
}

.menu-toggle-contents > svg {
  width: 16px;
}

.menu-item-row {
  gap: @space-8;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 12px;
}

.menu-item-row svg {
  width: 14px;
  flex-shrink: 0;
}

.menu-item-row-delete {
  gap: @space-8;
  align-items: center;
  flex-wrap: nowrap;
  font-size: 12px;
  color: var(--red-700);
}

.menu-item-row-delete svg {
  width: 14px;
  flex-shrink: 0;
}

.add-unit-row {
  padding: @space-8 @space-0;
}

.icon-wrapper {
  align-items: center;
}

.info-icon {
  height: 16px;
  width: 100%;
  vertical-align: middle;
  margin-right: @space-4;
  color: var(--blue-600);
}

.info-text {
  flex: 1 0 0;
  margin-left: @space-4;
  margin-top: 2px;
}

.conversion-summary {
  margin-top: @space-16;
  padding: @space-12 @space-16;
  background-color: var(--gray-F4F6F8);
  border-radius: @space-4;
  border: 1px solid var(--gray-CFD1D3);
}

.conversion-summary-title {
  color: var(--gray-0F0F10);
  margin-bottom: @space-8;
}

.conversion-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.conversion-item {
  display: block;
  padding: 0;
  color: var(--gray-637381);
  font-size: 12px;
}

.delete-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}
